import { useEffect } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useEnrollConstituentPsfExperiment } from '#src/app/pages/psf/shared/hooks';
import { useConstituentStatus } from '#src/app/shared/constituents';

/**
 * Constituents-in-PSF (CHANGE-100768): enrolls (treats + fires `$exposure`) an identified local
 * constituent when the share page renders, in every arm, control included. Most participants are
 * already enrolled by then, when they opened the combo page's "Share petition" sheet; this covers the
 * ones who reach the share page without it (for example after chipping in). The shared hook enrolls a
 * signer only once per petition per tab, whichever surface comes first.
 *
 * `useConstituentStatus` resolves asynchronously (`null` on first render), so this enrolls once the
 * value resolves to an identified constituent; a `null` status (pending or non-constituent) never does.
 */
export function useTreatConstituentPsfExperiment(): void {
	const {
		data: {
			petition,
			experiments: { constituentPsfExperiment: experiment },
		},
	} = usePsfSharePageData();
	const [constituentStatus] = useConstituentStatus(petition.id);
	const enroll = useEnrollConstituentPsfExperiment({ petitionId: petition.id, petition, experiment });

	useEffect(() => {
		void enroll(constituentStatus);
	}, [enroll, constituentStatus]);
}
